<template>
  <div style="padding: 20px; height: 63vh">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-card>
          <div slot="header" class="clearfix">
            <span class="title-list">REPORTES TRANSVERSALES</span>
          </div>
          <a class="title-link" @click="downloadQuincenalReport('todo')">REPORTE ESTADO DE RIESGOS PENDIENTES DE TODAS
            LAS OPERACIONES</a>
          <br>
          <a class="title-link" @click="downloadQuincenalReport('spence')">REPORTE ESTADO DE RIESGOS PENDIENTES DE TODAS
            LAS OPERACIONES (SPENCE)</a>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <div slot="header" class="clearfix">
            <span class="title-list">REPORTES POR FAENA</span>
          </div>
          <el-row :gutter="26">
            <el-col :sm="10">
              <el-form label-position="left">
                <el-form-item label="Seleccione Faena">
                  <el-select v-model="faena_selected" size="medium" style="width: 100%" placeholder="Seleccione Faena">
                    <el-option v-for="item in listadoFaenas" :key="item.faena_id" :label="item.nombre"
                      :value="item.faena_id"></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <el-row :gutter="30">
            <el-col :sm="24">
              <div>
                <hr style="margin-bottom: 20px" />
                <span class="title-report">REPORTE DE TAREAS PARA CIS</span>
                <br><br>
                <div>Seleccione los estados de los inventarios a incluír en el reporte</div>
                <el-select style="margin-top: 10px; margin-bottom: 10px; width: 100%;" v-model="estados_selected"
                  multiple placeholder="Seleccione los estados que desea incluír en el reporte">
                  <el-option v-for="item in estados" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <div style="margin-top: 10px;">Seleccione el tipo de contratos a incluír en el reporte</div>
                <el-select style="margin-top: 10px; margin-bottom: 10px; width: 100%;" v-model="tipo_selected" multiple
                  placeholder="Seleccione el tipo de contratos a incluír en el reporte">
                  <el-option v-for="item in tipos_contrato" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <br>
                <el-button style="margin-top: 10px;" size="small" type="primary" @click="downloadTaskRisks">DESCARGAR
                  REPORTE</el-button>
                <br><br>
                <h4 class="title-report">GENERALES</h4>
                <hr style="margin-bottom: 5px" />
                <a class="title-link" @click="downloadReportSuperintendencia('all')">REPORTE DE RIESGOS POR
                  SUPERINTENDENCIA PROPIOS Y
                  CONTRATISTAS</a>
                <br />
                <a class="title-link" @click="downloadWeekReport">REPORTE SEMANAL (DETALLADO)</a>
                <br />
                <a class="title-link" @click="downloadStandardizedRisk">REPORTE DE RIESGOS ESTANDARIZADOS</a>
                <br />
                <a class="title-link" @click="downloadAreaReport">REPORTE DE ÁREAS</a>
                <br />
                <!-- <a class="title-link" @click="downloadReportNotificaciones"
                  >REPORTE RIESGOS PENDIENTES POR USUARIOS / NOTIFICACIONES</a
                >
                <br /> -->
                <br />
                <h4 class="title-report">PROPIOS</h4>
                <hr style="margin-bottom: 5px" />
                <a class="title-link" @click="downloadReportSuperintendencia('propios')">REPORTE DE RIESGOS POR
                  SUPERINTENDENCIA PROPIOS</a>
                <br />
                <a class="title-link" @click="downloadTaskRiskReportPropios">REPORTE TAREAS Y RIESGOS (PROPIOS)</a>
                <br />
                <a class="title-link" @click="downloadRiesgosPendientesPropios">REPORTE DE RIESGOS PENDIENTES
                  (PROPIOS)</a>
                <br />
                <a class="title-link" @click="downloadinventoryApproved('Propio')">REPORTE DE INVENTARIOS APROBADOS
                  (PROPIOS)</a>
                <br />
                <br />
                <h4 class="title-report">CONTRATISTAS</h4>
                <hr style="margin-bottom: 5px" />
                <a class="title-link" @click="downloadReportSuperintendencia('contratistas')">REPORTE DE RIESGOS POR
                  SUPERINTENDENCIA CONTRATISTAS</a>
                <br />
                <a class="title-link" @click="downloadTaskRiskReportContratistas">REPORTE TAREAS Y RIESGOS
                  (CONTRATISTAS)</a>
                <br />
                <a class="title-link" @click="downloadRiesgosPendientesContratistas">REPORTE DE RIESGOS PENDIENTES
                  (CONTRATISTAS)</a>
                <br />
                <a class="title-link" @click="downloadinventoryApproved('Contratista')">REPORTE DE INVENTARIOS APROBADOS
                  (CONTRATISTAS)</a>
                <br />
                <br />
              </div>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <br />
  </div>
</template>

<script>
import axios from "axios";

export default {
  components: {},
  data() {
    return {
      tipo_selected: ["Propio", "Contratista"],
      tipos_contrato: [{
        value: 'Propio',
        label: 'Propio'
      }, {
        value: 'Contratista',
        label: 'Contratista'
      }],
      estados: [{
        value: 0,
        label: 'Borrador'
      }, {
        value: 1,
        label: 'En revisión'
      }, {
        value: 2,
        label: 'Aprobado'
      }, {
        value: 3,
        label: 'Importado en borrador'
      }],
      estados_selected: [0, 1, 2, 3],
      faena_selected: "5a6f78337b772dcfe68241d5",
      listadoFaenas: [
        {
          nombre: "MEL",
          faena_id: "5a6f78337b772dcfe68241d5",
        },
        {
          nombre: "SPENCE",
          faena_id: "5a6f78417b772dcfe68241e5",
        },
        {
          nombre: "CERRO COLORADO",
          faena_id: "5a6f784e7b772dcfe68241f4",
        },
        {
          nombre: "BHP",
          faena_id: "5b48f15d6f0ed90fc02826e3",
        },
      ],
    };
  },
  created() {
    this.$store.dispatch("setSubTitle", "Administración de reportes");
  },
  computed: {},
  methods: {
    downloadTaskRisks() {
      window.location.href = `https://bhp.lifeon.cl/data-science/reporteTareasRiesgos/${this.faena_selected}/${JSON.stringify(this.tipo_selected)}/${JSON.stringify(this.estados_selected)}`;
    },
    downloadReportNotificaciones() {
      window.location.href = `https://bhp.lifeon.cl/data-science/UsuariosRiesgosPendientes/${this.faena_selected}`;
    },
    downloadReportSuperintendencia(tipo) {
      window.location.href = `https://bhp.lifeon.cl/data-science/reportePorSuperintendencias/${this.faena_selected}/${tipo}`;
    },
    downloadinventoryApproved(tipo) {
      window.location.href = `https://bhp.lifeon.cl/data-science/reportes/get-inventories-approved/${this.faena_selected}/${tipo}`;
    },
    viewWeekReport() {
      this.$router.push({ name: "reportWeek" });
    },
    downloadStatusInventory() {
      window.location.href = `https://bhp.lifeon.cl/data-science/alejandra/reporte/${this.faena_selected}`;
    },
    downloadQuincenalReport(tipo) {
      const f = new Date().toJSON().slice(0, 10).replace(/-/g, "-");
      if (tipo === "spence") {
        window.location.href = `https://bhp.lifeon.cl/data-science/reportes/estado-pendientes/${f}/all/true`;
      } else {
        window.location.href = `https://bhp.lifeon.cl/data-science/reportes/estado-pendientes/${f}/all/false`;
      }
    },
    downloadTaskRiskReportContratistas() {
      window.location.href = `https://bhp.lifeon.cl/data-science/reportes/detalle-inventarios-contratistas/${this.faena_selected}`;
    },
    downloadStandardizedRisk() {
      window.location.href = `https://bhp.lifeon.cl/data-science/reportes/get-risks-standardized/${this.faena_selected}`;
    },
    downloadTaskRiskReportPropios() {
      window.location.href = `https://bhp.lifeon.cl/data-science/reportes/detalle-inventarios-propios/${this.faena_selected}`;
    },
    downloadAreaReport() {
      window.location.href = `https://bhp.lifeon.cl/data-science/reportes/reporte-areas/${this.faena_selected}`;
    },
    downloadWeekReport() {
      let name_faena = "";
      if (this.faena_selected === "5a6f78337b772dcfe68241d5") {
        name_faena = "mel";
      }
      if (this.faena_selected === "5a6f78417b772dcfe68241e5") {
        name_faena = "spence";
      }
      if (this.faena_selected === "5a6f784e7b772dcfe68241f4") {
        name_faena = "cmcc";
      }
      window.location.href = `https://bhp.lifeon.cl/data-science/naid/informe/${name_faena}`;
    },
    downloadRiesgosPendientesPropios() {
      window.location.href = `https://bhp.lifeon.cl/data-science/reportes/reporteRiesgosPendientes/${this.faena_selected}/Propio`;
    },
    downloadRiesgosPendientesContratistas() {
      window.location.href = `https://bhp.lifeon.cl/data-science/reportes/reporteRiesgosPendientes/${this.faena_selected}/Contratista`;
    },
  },
};
</script>

<style scoped>
.title-link {
  font-size: 14px;
  font-weight: bold;
  color: black;
}

.title-report {
  font-size: 15px;
  font-weight: bold;
  color: rgb(246, 123, 47);
}

.title-list {
  font-size: 15px;
  font-weight: bold;
  color: rgb(246, 123, 47);
}

.title-link:hover {
  color: green;
  cursor: pointer;
}
</style>
